<script setup>
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';
    import axios from "../../../setup/axios";

    const { t } = useI18n();

    const props = defineProps({
        links: {
            type: Object,
            required: true,
        },

        index: {
            type: Number,
            required: true,
        },
    });

    const isUserSiggnedIn = computed(() => {
        return window.Liferay?.ThemeDisplay?.isSignedIn() === true;
    });

    const currenProductID = computed(() => {
        if(props.links.id !== null && props.links.id !== "") {
            return props.links.id;
        }
    });

    function hideAllPopups() {
        let $productDownloads = document.querySelector("section.product-downloads");
        let $allPopups = $productDownloads.querySelectorAll('.download-popup');

        if ($allPopups !== null && $allPopups !== undefined) {

            $productDownloads.classList.remove('show-secure-dialog');
            $productDownloads.classList.remove('show-disti-dialog');

            $allPopups.forEach(function ($currentPopup) {
                if (!$currentPopup.classList.contains('is-hidden')) {
                    $currentPopup.classList.add('is-hidden');

                    let $currentDownloadSecureText = null;
                    let $currentDownloadSecureSuccess = null;
                    let $currentDownloadSecureError = null;
                    let $currentDownloadSecurePending = null;
                    let $currentDownloadSecureGranted = null;
                    let $currentRequestSecureButton = null;
                    let $currentDownloadSecureButton = null;
                    $currentDownloadSecureText =
                        $currentPopup.querySelectorAll('.text-container.normal')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.text-container.normal')[0]
                            : null;

                    $currentDownloadSecureSuccess =
                        $currentPopup.querySelectorAll('.text-container.success')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.text-container.success')[0]
                            : null;

                    $currentDownloadSecureError =
                        $currentPopup.querySelectorAll('.text-container.error')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.text-container.error')[0]
                            : null;

                    $currentDownloadSecurePending =
                        $currentPopup.querySelectorAll('.text-container.pending-request')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.text-container.pending-request')[0]
                            : null;
                    $currentDownloadSecureGranted =
                        $currentPopup.querySelectorAll('.text-container.already-granted')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.text-container.already-granted')[0]
                            : null;

                    $currentRequestSecureButton =
                        $currentPopup.querySelectorAll('.request.button')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.request.button')[0]
                            : null;

                    $currentDownloadSecureButton =
                        $currentPopup.querySelectorAll('.download.button')[0] !== undefined
                            ? $currentPopup.querySelectorAll('.download.button')[0]
                            : null;
                    if ($currentDownloadSecureButton !== null) {
                        $currentDownloadSecureButton.removeEventListener('click', downloadFile);
                    }

                    if ($currentDownloadSecureSuccess !== null) {
                        $currentDownloadSecureSuccess.classList.add('is-hidden');
                        $currentDownloadSecureError.classList.add('is-hidden');
                        $currentDownloadSecureText.classList.remove('is-hidden');
                        $currentDownloadSecurePending.classList.add('is-hidden');
                        $currentDownloadSecureGranted.classList.add('is-hidden');
                        $currentRequestSecureButton.classList.remove('is-hidden');
                        $currentDownloadSecureButton.classList.add('is-hidden');
                    }
                }
            });
        }
    }

    function downloadFile(event) {
        if (props.links.id !== null && props.links.id !== "") {
            event.preventDefault();
            event.stopPropagation();
            window.open('/o/download-server/document-download/download/' + props.links.id, '_blank');
            hideAllPopups();
        }
    }

    function requestDownloadFile(event) {
        if (props.links.id !== null && props.links.id !== "") {
            const fileID = props.links.id;
            event.preventDefault();
            event.stopPropagation();

            let $requestSecureButton = event.target.parentElement.querySelector(".request.button");
            let $downloadSecureError = event.target.parentElement.parentElement.querySelector('.text-container.error');
            let $downloadSecurePending = event.target.parentElement.parentElement.querySelector('.text-container.pending-request');
            let $downloadSecureGranted = event.target.parentElement.parentElement.querySelector('.text-container.already-granted');
            let $downloadSecureText = event.target.parentElement.parentElement.querySelector('.text-container.normal');
            let $downloadSecureSuccess = event.target.parentElement.parentElement.querySelector('.text-container.success');
            let $downloadSecureButton = event.target.parentElement.parentElement.querySelector('.download.button');

            $requestSecureButton.classList.add('is-loading');
            $requestSecureButton.setAttribute('disabled', 'disabled');
            axios
                .get('/o/download-server/download-permission-request/request/' + fileID)
                .then(response => {
                    if (
                        response.status === 200 &&
                        response.data !== null &&
                        response.data !== undefined
                    ) {
                        $downloadSecureError.classList.add('is-hidden');
                        $downloadSecurePending.classList.add('is-hidden');
                        $downloadSecureGranted.classList.add('is-hidden');
                        $downloadSecureText.classList.add('is-hidden');
                        $requestSecureButton.classList.add('is-hidden');
                        $downloadSecureSuccess.classList.remove('is-hidden');
                    } else {
                        $downloadSecureSuccess.classList.add('is-hidden');
                        $downloadSecureText.classList.add('is-hidden');
                        $downloadSecurePending.classList.add('is-hidden');
                        $downloadSecureGranted.classList.add('is-hidden');
                        $downloadSecureError.classList.remove('is-hidden');
                        $requestSecureButton.classList.remove('is-hidden');
                        $downloadSecureButton.classList.add('is-hidden');
                    }
                })
                .catch(error => {
                    if (
                        error !== null &&
                        error !== undefined &&
                        error.response !== null &&
                        error.response !== undefined &&
                        error.response.data !== null &&
                        error.response.data !== undefined &&
                        (error.response.data === 'download permission GRANTED' ||
                            error.response.data ===
                            'no request created - pending request already exists')
                    ) {
                        $requestSecureButton.classList.add('is-hidden');
                        $downloadSecureSuccess.classList.add('is-hidden');
                        $downloadSecureText.classList.add('is-hidden');
                        $downloadSecurePending.classList.add('is-hidden');
                        $downloadSecureGranted.classList.add('is-hidden');
                        $downloadSecureError.classList.add('is-hidden');

                        if (error.response.data === 'download permission GRANTED') {
                            $downloadSecureGranted.classList.remove('is-hidden');
                            $downloadSecureButton.classList.remove('is-hidden');
                        } else if (
                            error.response.data ===
                            'no request created - pending request already exists'
                        ) {
                            $downloadSecurePending.classList.remove('is-hidden');
                            $downloadSecureButton.classList.add('is-hidden');
                        }
                    } else {
                        $downloadSecureSuccess.classList.add('is-hidden');
                        $downloadSecureText.classList.add('is-hidden');
                        $downloadSecurePending.classList.add('is-hidden');
                        $downloadSecureGranted.classList.add('is-hidden');
                        $downloadSecureButton.classList.add('is-hidden');

                        $downloadSecureError.classList.remove('is-hidden');
                        $requestSecureButton.classList.remove('is-hidden');
                    }
                })
                .finally(() => {
                    $requestSecureButton.removeAttribute('disabled');
                    $requestSecureButton.classList.remove('is-loading');
                });
        }
    }
</script>

<template>
    <div :id="currenProductID" class="download-popup secure-download-popup is-hidden">
        <div class="download-popup-content">
            <div v-if="isUserSiggnedIn" class="text-container normal">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedIn') }}
                </h2>
                <p>
                    {{ t('productDetails.Download.Secure.Dialog.Text.LoggedIn') }}
                </p>
            </div>
            <div v-if="isUserSiggnedIn" class="text-container success is-hidden">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedIn.Success') }}
                </h2>
                <p>
                    {{ t('productDetails.Download.Secure.Dialog.Text.LoggedIn.Success') }}
                </p>
            </div>
            <div v-if="isUserSiggnedIn" class="text-container error is-hidden">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedIn.Error') }}
                </h2>
                <p>
                    {{ t('productDetails.Download.Secure.Dialog.Text.LoggedIn.Error') }}
                </p>
            </div>
            <div v-if="isUserSiggnedIn" class="text-container already-granted is-hidden">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedIn.Granted') }}
                </h2>
                <p>
                    {{ t('productDetails.Download.Secure.Dialog.Text.LoggedIn.Granted') }}
                </p>
            </div>
            <div v-if="isUserSiggnedIn" class="text-container pending-request is-hidden">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedIn.Pending') }}
                </h2>
                <p>
                    {{ t('productDetails.Download.Secure.Dialog.Text.LoggedIn.Pending') }}
                </p>
            </div>

            <div v-if="isUserSiggnedIn" class="links-container">
                <button :data-request-id="currenProductID.value" class="request button is-primary" @click="requestDownloadFile($event)">
                    {{ t('productDetails.Download.Secure.Dialog.Request.Download') }}
                </button>
                <button class="download button is-primary is-hidden" @click="downloadFile($event)">
                    {{ t('productDetails.Download.Secure.Dialog.Download') }}
                </button>
                <button  class="decline button is-secondary" @click="hideAllPopups">
                    {{ t('productDetails.Download.Secure.Dialog.Close') }}
                </button>
            </div>
            <div v-if="!isUserSiggnedIn" class="text-container normal">
                <h2 class="title is-3">
                    {{ t('productDetails.Download.Secure.Dialog.Title.LoggedOut') }}
                </h2>
                <div v-html="t('productDetails.Download.Secure.Dialog.Text.LoggedOut')"></div>
                <div class="links-container">
                    <a href="/c/portal/login" class="login button is-primary">
                        {{ t('productDetails.Download.Secure.Dialog.SignIn') }}
                    </a>
                    <button class="decline button is-secondary" @click="hideAllPopups">
                        {{ t('productDetails.Download.Secure.Dialog.Close') }}
                    </button>
                </div>
            </div>
        </div>
        <button class="button close-dialog" @click="hideAllPopups">
            <span>&times;</span>
        </button>
    </div>
</template>
